// extracted by mini-css-extract-plugin
export var errorIcon = "_kc-1";
export var nameLogo = "_kc-0";